export enum UserFlag {
  ENABLE_AGENCY_PARTNER_STACK = 'enable_agency_partner_stack',
  ENABLE_MOBILE_APP_BANNER_BY_RULE_EXPERIMENT = 'enable_mobile_app_banner_by_rule_experiment',
  MANDATORY_EMAIL_VERIFICATION = 'mandatory_email_verification',
  ENABLE_AI_INTERVIEWS_GENERAL = 'enable_ai_interviews_general',
  ENABLE_AI_INTERVIEWS_HOME_TAB = 'enable_ai_interviews_home_tab',
  DISABLE_BRAZE_NOTIFICATIONS_FOR_WEB_VIEW = 'disable_braze_notifications_for_web_view',
  ENABLE_BRAZE_PUSH_NOTIFICATIONS = 'enable_braze_push_notifications',
  ENABLE_BILLING_SUBMODULES = 'enable_billing_submodules',
}

export enum AccountFlag {
  ENABLE_FACELIFTING_FOR_CONFERENCE = 'enable_facelifting_for_conference',
  ENABLE_IG_RECURRING_NOTIFICATION = 'enable_ig_recurring_notification',
  ENABLE_INBOX = 'enable_inbox',
  ENABLE_INBOX_ADDON = 'enable_inbox_addon',
  ENABLE_INDIAN_CUSTOMERS_3DS_RESUBSCRIPTION = 'enable_indian_customers_3ds_resubscription',
  ENABLE_LC_STATISTICS = 'enable_lc_statistics',
  ENABLE_WEBVIEW = 'enable_webview',
  FETCH_STORIES_FROM_CDN = 'fetch_stories_from_cdn',
  UKRAINE_2022_SUPPORT = 'ukraine_2022_support',
  UKRAINE_2022_SUPPORT_SHOW_MODAL = 'ukraine_2022_support_show_modal',
  WA_CLOUD_API_RECONNECT_ALLOWED = 'wa_cloud_api_reconnect_allowed',
  ENABLE_DM_LIST_IMPROVEMENTS = 'enable_dm_list_improvements',
  ENABLE_IG_CROSS_CHANNEL_BUTTON = 'enable_ig_cross_channel_button',
  ENABLE_WA_CATALOG = 'enable_wa_catalog',
  NOT_CHECKED_FOR_IMPORT_UNIFIED_SUBSCRIBERS = 'not_checked_for_import_unified_subscribers',
  ENABLE_GOOGLE_SHEETS_ACTION_CONFIG_FALLBACK = 'google_sheets_action_config_fallback',
  ENABLE_HIGHLIGHT_INSTRUMENT = 'enable_highlight_instrument',
  ENABLE_AI_BUSINESS_CONTEXT = 'enable_ai_business_context',
  ENABLE_HIGHLIGHT_FOR_TIKTOK = 'enable_highlight_for_tiktok',
  ENABLE_AI_PAYWALL = 'enable_ai_paywall',
  ENABLE_CTA_IG_REG_FLOW_EXPERIMENT = 'enable_cta_ig_reg_flow_experiment',
  DISABLE_CTA_IG_REG_FLOW_EXPERIMENT = 'disable_cta_ig_reg_flow_experiment',
  ENABLE_TIKTOK_ADS_TRIGGER = 'enable_tiktok_ads_trigger',
  ENABLE_IN_APP_CARD_ATTACHMENT = 'enable_in_app_card_attachment',
  DISABLE_IN_APP_CARD_ATTACHMENT = 'disable_in_app_card_attachment',
  ENABLE_BILLING_ADDRESS_ONLY_US = 'enable_billing_address_only_us',
  DISABLE_BILLING_ADDRESS_ONLY_US = 'disable_billing_address_only_us',
  ENABLE_AI_ALWAYS_ON_AUTOMATION = 'enable_ai_always_on_automation',
  ENABLE_IN_APP_CHECKOUT_BRAZIL = 'in_app_checkout_brazil',
  ENABLE_IN_APP_CHECKOUT_BRAZIL_REGFLOW = 'in_app_checkout_brazil_regflow',
  ENABLE_PRIVATE_REPLY_TO_FOLLOW = 'enable_private_reply_to_follow',
  ENABLE_IG_FOLLOW_REPLY_TRIGGER = 'enable_ig_follow_reply_trigger',
  ENABLE_IG_SELF_MESSAGE = 'enable_ig_self_message',
  IG_SELF_MESSAGE_ALLOWED = 'ig_self_message_allowed',
  ENABLE_NON_EMPTY_WALLET_AS_BLOCKER_FOR_DELETION = 'enable_non_empty_wallet_as_blocker_for_deletion',
  ENABLE_UPGRADE_FROM_TRIAL = 'enable_upgrade_from_trial',
  ENABLE_IG_SUMMIT_TICKET_LAUNCH_BANNER = 'enable_ig_summit_ticket_launch_banner',

  ENABLE_FB_MARKETING_MESSAGES = 'enable_fb_marketing_messages',
  ENABLE_NEW_HOMETAB_VERSION = 'enable_new_hometab_version',
  ENABLE_NEW_HOMETAB_MOST_ENGAGED_FOLLOWERS = 'enable_new_hometab_most_engaged_followers',
  ENABLE_NEW_CTA_ON_BAR = 'enable_new_cta_on_bar',
  ENABLE_IG_REG_PAYWALL_SKIP = 'enable_ig_reg_paywall_skip',
  ENABLE_LC_LABELS = 'enable_lc_labels',
  ENABLE_AI_AUTOMATION_BETA_TESTER_RECRUITMENT = 'enable_ai_automation_beta_tester_recruitment',
  ENABLE_AI_LEADQUAL_GOAL = 'enable_ai_leadqual_goal',
  ENABLE_UNIVERSAL_PAYWALL = 'enable_universal_paywall',
  ENABLE_PAYMENT_METHOD_ELEMENTS = 'enable_payment_method_elements',
  ENABLE_EASY_BUILDER_MULTITRIGGER = 'enable_easy_builder_multitrigger',
  DISABLE_EASY_BUILDER_MULTITRIGGER = 'disable_easy_builder_multitrigger',
  ENABLE_IG_SHARE_TO_STORY_PRIVATE_REPLY = 'enable_ig_share_to_story_private_reply',
  ENABLE_IG_SHARE_TO_STORY_TRIGGER = 'enable_ig_share_to_story_trigger',
  ENABLE_PERSONALIZED_RECOMMENDATION_SCREEN = 'enable_personalized_recommendation_screen',
  DISABLE_PERSONALIZED_RECOMMENDATION_SCREEN = 'disable_personalized_recommendation_screen',
  ENABLE_NEW_NAVIGATION = 'enable_new_navigation',
  INTEGRATIONS_IN_TEMPLATES = 'integrations_in_templates',
  ENABLE_INTEGRATIONS_IN_TEMPLATES = 'enable_integrations_in_templates',
  ENABLE_IG_RECONNECT_VIA_FBL4B = 'enable_ig_reconnect_via_fbl4b',
  ENABLE_IG_RECONNECT_VIA_IG_OAUTH = 'enable_ig_reconnect_via_ig_oauth',
}
